(function(){
  "use strict";
  function money(c,f){var v=(c/100).toFixed(2);if(f&&f.indexOf("{{amount}}")!==-1)return f.replace("{{amount}}",v);if(f&&f.indexOf("{{amount_no_decimals}}")!==-1)return f.replace("{{amount_no_decimals}}",Math.round(c/100));return "$"+v;}

  function initIndex(scope){
    (scope||document).querySelectorAll("[data-index]").forEach(function(list){
      if(list.__bound)return; list.__bound=true;
      var peek=list.parentElement.querySelector(".idx__peek");
      if(!peek)return;
      var pimg=peek.querySelector("img");
      var raf=null,tx=0,ty=0,cx=0,cy=0,active=false;
      function loop(){cx+=(tx-cx)*.18;cy+=(ty-cy)*.18;peek.style.left=cx+"px";peek.style.top=cy+"px";if(active||Math.abs(tx-cx)>.5)raf=requestAnimationFrame(loop);else raf=null;}
      list.querySelectorAll(".idx__row").forEach(function(row){
        var src=row.getAttribute("data-img");
        row.addEventListener("mouseenter",function(){active=true;list.classList.add("is-hovering");if(src&&pimg&&pimg.getAttribute("src")!==src)pimg.src=src;peek.classList.add("show");if(!raf)raf=requestAnimationFrame(loop);});
      });
      list.addEventListener("mousemove",function(e){tx=e.clientX;ty=e.clientY;if(!raf)raf=requestAnimationFrame(loop);});
      list.addEventListener("mouseleave",function(){active=false;list.classList.remove("is-hovering");peek.classList.remove("show");});
    });
  }

  document.addEventListener("click",function(e){
    var b=e.target.closest("[data-burger]");
    if(b){var m=document.getElementById("mobile-menu");if(m)m.classList.toggle("open");return;}
    var s=e.target.closest(".size:not(.dis)");
    if(s){var g=s.closest("[data-option-index]")||s.parentElement;g.querySelectorAll(".size").forEach(function(x){x.classList.remove("on");});s.classList.add("on");}
    var w=e.target.closest(".sw");
    if(w){var img=document.getElementById("pdpImg");var src=w.getAttribute("data-img");if(img&&src)img.src=src;var nm=document.getElementById("swName");if(nm)nm.textContent=w.getAttribute("data-name")||"";}

  });

  /* Variant picker */
  function initForms(scope){
    (scope||document).querySelectorAll("[data-product-form]").forEach(function(form){
      if(form.__bound)return; form.__bound=true;
      var d=form.querySelector("[data-variant-json]");if(!d)return;var variants;try{variants=JSON.parse(d.textContent);}catch(e){return;}
      var fmt=form.getAttribute("data-money-format")||"${{amount}}";
      var idInput=form.querySelector("[name='id']"),priceEls=form.querySelectorAll("[data-price]"),atc=form.querySelector(".atc"),atcLabel=form.querySelector("[data-atc-label]"),groups=form.querySelectorAll("[data-option-index]");
      function sel(){var o=[];groups.forEach(function(g){var i=parseInt(g.getAttribute("data-option-index"),10);var on=g.querySelector(".size.on");o[i]=on?on.getAttribute("data-value"):null;});return o;}
      function find(o){return variants.find(function(v){return o.every(function(val,i){return val===null||v.options[i]===val;});});}
      function upd(){var v=find(sel());if(!v)return;if(idInput)idInput.value=v.id;var html=money(v.price,fmt);if(v.compare_at_price&&v.compare_at_price>v.price)html="<s>"+money(v.compare_at_price,fmt)+"</s> "+money(v.price,fmt);priceEls.forEach(function(p){p.innerHTML=html;});if(atc){atc.disabled=!v.available;if(atcLabel)atcLabel.textContent=v.available?"Add to bag":"Sold out";}}
      form.querySelectorAll(".size:not(.dis)").forEach(function(btn){btn.addEventListener("click",upd);});
      upd();
    });
  }

  /* Qty steppers */
  function initQty(scope){
    (scope||document).querySelectorAll("[data-qty]").forEach(function(w){
      if(w.__bound)return; w.__bound=true;
      var input=w.querySelector("input");
      w.querySelectorAll("button").forEach(function(b){b.addEventListener("click",function(){var s=b.getAttribute("data-step")==="down"?-1:1;input.value=Math.max(0,(parseInt(input.value,10)||0)+s);if(input.form)input.form.requestSubmit?input.form.requestSubmit():input.form.submit();});});
    });
  }

  function initAll(scope){initIndex(scope);initForms(scope);initQty(scope);}
  document.addEventListener("DOMContentLoaded",function(){initAll(document);});
  initAll(document);
  document.addEventListener("shopify:section:load",function(e){initAll(e.target);});
})();
